import { Box, styled } from "@mui/material";

export const Label = styled(Box)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  letterSpacing: 0.5,
}));
